import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Constants } from '../../shared/Helpers/constants';
import { Router } from '@angular/router';
import { UserService } from 'src/app/_services';
import { SharedService } from 'src/app/shared/shared.service';
import { GlobalValidator } from 'src/app/shared';
import { Alert, AlertTypeEnum } from 'src/app/shared/Helpers/Alert';

@Component({
  selector: 'forgot-username',
  templateUrl: './forgot-username.component.html',
  styleUrls: ['./forgot-username.component.css']
})
export class ForgotUsernameComponent {
  public logoPath: any;
  public hideForm: boolean = false;
  public recoveryEmailForm: FormGroup;
  public emailSecQuesForm: FormGroup;
  public securityQuestionForm: FormGroup;
  public secQuestionsSelected: boolean = true;
  public securityQuestionsForEmail: any;
  public questionsLoaded: boolean = false;
  public recoveryEmailSelected: boolean = false;
  public secQuesToDisplay: any;
  public emailSubmitted: any = '';
  public dtoObject:any;
  public verifiedSecQuestions: boolean = false;
  public usernameReturned: any;

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService,
    private sharedService: SharedService,
    private router: Router
  ) {
    this.initRecoveryMailForm();
    this.initEmailSecQuesForm();
    this.initSecurityQuestionForm();
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

  private initRecoveryMailForm(): void {
    this.recoveryEmailForm = this._formBuilder.group({
      recoveryEmail: ['', [GlobalValidator.emailFormat, Validators.required]],
    });
  }

  public recoverPassword(): void {
    const email = { email: this.recoveryEmailForm.controls.recoveryEmail.value }
    this._userService.forgotPassword(email).subscribe({
      next: () => {
        this.hideForm = true;
      },
      error: (err) => {
        if(err.error.errorCode == 1000) {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", `Email address ${email.email} is not found as a validated recovery email address for any account.`);
        } else {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", `Email address ${email.email} is not found as a validated recovery email address for any account.`);
        }
      }
    })
  }

  private initEmailSecQuesForm(): void {
    this.emailSecQuesForm = this._formBuilder.group({
      email : ['', [GlobalValidator.emailFormat, Validators.required]]
    })
  }

  public loadSecurityQuestionsFromIDAM() {
    this.emailSubmitted = this.emailSecQuesForm.controls.email.value;
    const emailEncoded: string = encodeURIComponent(this.emailSubmitted);

    this._userService.getSecurityQuestionsByEmail(emailEncoded).subscribe({
      next: (res) => {
        this.securityQuestionsForEmail = res.body;

        if (this.securityQuestionsForEmail.length == 0) {
          Alert.basicNotification(AlertTypeEnum.Warning, "Warning", "You do not have security questions set up in Able+. Please use your recovery email address instead.");
        } else {
          this.questionsLoaded = true;
          this.patchSecurityQuestionForm();
        }
      },
      error: (err) => {
        const errorMessage: string = `Recovery email address not recognised. Please make sure you have verified your email address or contact your organisation's Able+ administrator.`;
        Alert.basicNotification(AlertTypeEnum.Warning, "Warning", errorMessage);
      }
    })
  }

  public onSelectSecQuestions() {
    this.secQuestionsSelected = true;
    this.recoveryEmailSelected = false;
  }

  public onSelectRecEmail() {
    this.recoveryEmailSelected = true;
    this.secQuestionsSelected = false;
  }

  private initSecurityQuestionForm() {
    this.securityQuestionForm = this._formBuilder.group({
      securityQuestion: this._formBuilder.array([
        this._formBuilder.group({
          id: [''],
          name: [''],
          answer: ['', [Validators.required]],
          question: [''],
          version: ['']
        })
      ]),
      recoveryEmail: [this.emailSubmitted]
    });
    (<FormArray>this.securityQuestionForm.controls.securityQuestion).removeAt(0);
  }

  private patchSecurityQuestionForm() {
    this.secQuesToDisplay = <FormArray>this.securityQuestionForm.controls['securityQuestion'];
    for (let i = 0; i < this.securityQuestionsForEmail.length; i++) {
      const newSecurityQuesiton = this._formBuilder.group({
        id: [this.securityQuestionsForEmail[i].id],
        name: [this.securityQuestionsForEmail[i].name],
        answer: ['', [Validators.required]],
        question: [this.securityQuestionsForEmail[i].question],
        version: [this.securityQuestionsForEmail[i].version]
      })

      this.secQuesToDisplay.push(newSecurityQuesiton);
    }
  }

  public verifyAnswersForSecurityQuestions() {
    const questions: any = this.securityQuestionForm.value;
    if (questions.securityQuestion.length > 0) {
      this.dtoObject = {
        email: this.emailSubmitted,
        securityAnswers: this.createAnswersArrayObject(questions.securityQuestion)
      }

      this._userService.verifySecurityQuestionsViaEmail(this.dtoObject).subscribe({
        next: (res) => {
          this.usernameReturned = res.body;
          this.verifiedSecQuestions = true;
        },
        error: (err) => {
          if(err?.error?.errorCode == 1006) {
            Alert.basicNotification(AlertTypeEnum.Warning, "", "One or more of your answers were incorrect and therefore it is not possible to authenticate your details for login. Try again or use your recovery email address instead. Alternatively contact your Able+ administrator to reset the password for you.");
            this.router.navigate(['login']);
          } else {
            Alert.basicNotification(AlertTypeEnum.Error, "", "You appear to be offline. Please check your connection and try again.");
          }
        }
      })
    }
  }

  private createAnswersArrayObject(object) {
    let answers: object = {};
    let response: any = [];
    object.forEach(item => {
      answers =  {
        answer: item.answer,
        version: item.version,
        securityQuestion: {
          id: item.id
        }
      };
      response.push(answers);
    })
    return response;
  }

}
